const STATUS = {
  ESTATAL_STATUS: 'Estatal',
  TCP: 'TCP',
  JUBILADO_STATUS: 'Jubilado',
  SIN_EMPLEO_STATUS: 'Sin Empleo',
  EXTERIOR_STATUS: 'Exterior',
  PRIVATE_MIPYME: 'MiPyME Privada',
  STATE_MIPYME: 'MiPyME Estatal',
  CNA: 'CNA',
};
/**
 * Enum definition.
 *
 * @type {string[]}
 */
const STATUS_ENUM = Object.keys(STATUS);

const ESTATAL_STATUS = STATUS_ENUM[0];
const TCP = STATUS_ENUM[1];
const JUBILADO_STATUS = STATUS_ENUM[2];
const SIN_EMPLEO_STATUS = STATUS_ENUM[3];
const EXTERIOR_STATUS = STATUS_ENUM[4];
const PRIVATE_MIPYME = STATUS_ENUM[5];
const STATE_MIPYME = STATUS_ENUM[6];
const CNA = STATUS_ENUM[7];

export {
  STATUS_ENUM,
  STATUS,
  ESTATAL_STATUS,
  TCP,
  JUBILADO_STATUS,
  SIN_EMPLEO_STATUS,
  EXTERIOR_STATUS,
  PRIVATE_MIPYME,
  STATE_MIPYME,
  CNA,
};
